import MainRouter from '../../config/MainRouter';
import CoreAPI from './coreApp';

MainRouter.addRoutes(
    [
        {
            definition: '*notFound',
            methodName: 'routeWithReact',
        },
    ],
    CoreAPI
);
